const OpenHelpTicketLink = () => (
  <a href='https://help.everplans.com/hc/en-us/requests/new?ticket_form_id=126457'>
    open a ticket
  </a>
)

export default OpenHelpTicketLink
